import React from "react";

const Next = () => {
  return (
    <div>
      <h1>Next.js</h1>
    </div>
  );
};

export default Next;
